import http from './http';

const claimFormAAPI = {
  // Create new Form A
  createForm: async (formData) => {
    const response = await http.post('/api/v1/claim-form-a', formData);
    return response.data;
  },

  // Get all forms with filters
  getAllForms: async (params = {}) => {
    const response = await http.get('/api/v1/claim-form-a', { params });
    return response.data;
  },

  // Get single form
  getFormById: async (id) => {
    const response = await http.get(`/api/v1/claim-form-a/${id}`);
    return response.data;
  },

  // Update form
  updateForm: async (id, formData) => {
    const response = await http.put(`/api/v1/claim-form-a/${id}`, formData);
    return response.data;
  },

  // Submit form
  submitForm: async (id) => {
    const response = await http.post(`/api/v1/claim-form-a/${id}/submit`);
    return response.data;
  },

  // Delete form
  deleteForm: async (id) => {
    const response = await http.delete(`/api/v1/claim-form-a/${id}`);
    return response.data;
  },

  // Get patient forms
  getPatientForms: async (patientId) => {
    const response = await http.get(`/api/v1/claim-form-a/patient/${patientId}`);
    return response.data;
  }
};

export default claimFormAAPI;
